<mat-toolbar>
  <span class="brand">{{ appName }}</span>

  <nav class="nav-center">
    <a class="nav-link" routerLink="/index" routerLinkActive="active">Home</a>
    <a class="nav-link" routerLink="/about" routerLinkActive="active">About</a>
  </nav>

  <mat-select
    class="theme-select"
    [value]="themeService.current()"
    (selectionChange)="setTheme($event.value)"
    aria-label="Theme">
    <mat-option value="light">
      <mat-icon>light_mode</mat-icon> Light
    </mat-option>
    <mat-option value="system">
      <mat-icon>brightness_auto</mat-icon> System
    </mat-option>
    <mat-option value="dark">
      <mat-icon>dark_mode</mat-icon> Dark
    </mat-option>
  </mat-select>
</mat-toolbar>
